import { FC, memo } from 'react'

import { InnerWrapper, OuterSection, OuterWrapper, PopularFilterLink } from './styles'
import SortOptionTransport from '../../../../transports/common/sort-option-transport'
import ExternalLink from '../../../common/external-link'
import { useTranslation } from '../../../../hooks/locale'

interface SortOptionProps {
    sortOptions: SortOptionTransport[]
}

const SortOption: FC<SortOptionProps> = ({ sortOptions }) => {
    const { t } = useTranslation()

    return (
        <OuterWrapper>
            <InnerWrapper>
                <OuterSection>
                    {sortOptions.map(item => (
                        <ExternalLink as={PopularFilterLink} href={item.url} key={item.url} noCrawl={item.noCrawl}>
                            {t(item.label)}
                        </ExternalLink>
                    ))}
                </OuterSection>
            </InnerWrapper>
        </OuterWrapper>
    )
}

export default memo(SortOption)
